function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1078_371)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.36366 20.8969V10.1347L3.00858 7.08119L0 5.38672V18.9977C0 20.0485 0.855859 20.8969 1.90914 20.8969H6.36366Z",
  fill: "#4285F4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.6367 20.8968H26.0912C27.1477 20.8968 28.0004 20.0453 28.0004 18.9975V5.38672L24.5927 7.32753L21.6367 10.1346V20.8968Z",
  fill: "#34A853"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.36376 10.1341L5.90723 5.92901L6.36376 1.9043L14.0001 7.60193L21.6364 1.9043L22.1471 5.71172L21.6364 10.1341L14.0001 15.8318L6.36376 10.1341Z",
  fill: "#EA4335"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.6367 1.90455V10.1344L28.0004 5.38641V2.85412C28.0004 0.50549 25.3054 -0.833396 23.4187 0.575127L21.6367 1.90455Z",
  fill: "#FBBC04"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 5.38646L2.92677 7.57025L6.36366 10.1344V1.9046L4.58172 0.575177C2.69172 -0.833455 0 0.50554 0 2.85406V5.38635V5.38646Z",
  fill: "#C5221F"
}));
var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1078_371"
}, /*#__PURE__*/React.createElement("rect", {
  width: 28,
  height: 21,
  fill: "white"
})));
function SvgGmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 21,
    viewBox: "0 0 28 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmail);
export default __webpack_public_path__ + "static/media/gmail.199772f18528c90f2924ba3ab3381cee.svg";
export { ForwardRef as ReactComponent };